<template>
  <el-pagination
    background
    class="page"
    layout="total, prev, pager, next, sizes,jumper"
    :current-page.sync="config.currentPage"
    :page-sizes="config.sizes"
    :page-size="config.pageSize"
    :total="config.dataTotalCount"
    @size-change="sizeChange"
    @current-change="currentChange">
  </el-pagination>
</template>

<script>
export default {
  name: 'DataPagination',
  props: {
    config: Object
  },
  methods: {
    //分页 初始页currentPage、初始每页数据数pagesize和数据testpage--->控制每页几条
    sizeChange(size) {
      this.$emit('sizeChange', size)
    },

    // 控制页面的切换
    currentChange(currentpage) {
      this.$emit('currentChange', currentpage)
    }
  }

}
</script>

<style scoped>

</style>
